<script>
import Lightpick from 'lightpick'

export default {
  props: {
    options: { type: Object, default: () => ({}) },
  },
  mounted() {
    const vm = this
    this.picker = new Lightpick({
      field: vm.$el,
      singleDate: false,
      inline: true,
      // numberOfColumns: 3,
      numberOfMonths: 6,
    })
  },
  destroyed() {
    this.picker.destroy()
  },
}
</script>

<template>
  <input type="text" />
</template>
